<template>
  <div>
    <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 pt-2 pb-20 overflow-hidden mt-3">
      <div class="text-gray-700">
        <h3 class="text-xl uppercase font-medium text-gray-800 tracking-wide">Opakování učiva 4. ročníku</h3>
        <p class="mt-3">
          V loňském roce jsme se učili o některých událostech z nejstarších českých dějin. začali jsme obdobím <strong>pravěku</strong>, z něhož se nám nedochovaly žádné písemné památky. Museli jsme
          se vrátit o mnoho set tisíc let zpět, abychom si povídali o životě prvních lidí na našem území. O jejich způsobu života se dozvídáme na základě různých předmětů, které objevili archelogové
          při svých výzkumech. V průběhu tisíciletí se měnily přírodní podmínky a s nimi i život tehdejších lidí.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl  font-medium text-blue-600">České země v pravěku</h3>
        <p class="mt-3">
          Naši nejdávnější předkové byli <strong>lovci</strong> a <strong>sběrači</strong>. Jako hlavní nástroj používali opracovaný kámen. Zpočátku se odvažovali jen k lovu drobné zvěře, později si
          tlupy těchto pravěkých lovců troufaly na lov větších zvířat, nakonec i obrovských mamutů
          <a class="underline text-red-500 font-medium" target="_blank" href="https://cs.wikipedia.org/wiki/Mamut">(Více)</a>. Živili se rovněž sběrem lesních plodů nebo semen.
        </p>
        <p class="mt-3">
          Postupně se měnily přírodní podmínky. Doba ledová byla vystřídána teplejším podnebím. Lidé začali obdělávat půdu,
          <strong>lov</strong> a <strong>sběr</strong> vystřídalo <strong>zemědělství s chovem domácích zvířat</strong>. Jako materiál k výrobě zbraní, nářadí a nástrojů začali lidé používat i
          <strong>dřevo</strong>, později <strong>bronz</strong> a <strong>železo</strong>.
        </p>
        <p class="mt-3">
          V průběhu staletí se na našem území vystřídalo mnoho různých kmenů. Prvními pojmenovanými obyvateli zde byli
          <strong>Keltové</strong>. Byli zručnými staviteli a řemeslníky. Dokázali vyrábět předměty ze skla a znali také hrnčířský kruh. Při obchodování používali mince.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Příchod Slovanů</h3>
        <p class="mt-3">
          Asi od 5. století n. l. přicházeli do našich krajů <strong>Slované</strong>. Celá země byla tehdy porostlá hlubokými lesy, a proto se slovanské kmeny usazovaly podél řek a na některýh
          návrších. Slované se nejprve živili lovem, potom pastevectvím a chovem dobytka. Žili v malých osadách. Na obranu prti útokům z okolních zemí se kmeny spojovaly ve větší celky. Tak vznikl
          kmenový svaz, v jehož čele stál kupec <strong>Sámo</strong>.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Velkomoravská říše</h3>
        <p class="mt-3">
          Během 9. století vznikla na území Moravy a části Slovenska velká slovanská říše - <strong>Velká Morava</strong>. Toto období připomíná mnoho památek, které byly nalezeny při vykopávkách.
        </p>
        <p class="mt-3">
          Už od konce 8. století přicházeli na Moravu kněží z dnešního Německa a šířili zde <strong>křesťanství</strong>. Protože však mluvili německy nebo latinsky, Slované jim nerozuměli. Proto
          vládce Velkomoravské říše Rastislav povolal na Moravu dva vzdělané bratry <strong>Konstantina</strong> a <strong>Metoděje</strong>, kteří ovládali slovanský jazyk a začali ho používat při
          bohoslužbách. Spolu s šířením křesťanství sem přinesli bratři slovanské písmo (<a class="underline text-red-600 font-medium" target="_blank" href="https://cs.m.wikipedia.org/wiki/Hlaholice"
            >hlaholici</a
          >
          ) a základy různých řemesel. Slované se stávali kulturním národem ve střední Evropě.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Vznik českého státu, vláda přemyslovských knížat</h3>
        <p class="mt-3">
          Po rozpadu Velkomoravské říše začal na počátku 10. století vznikat v Čechách český stát, kde vládl rod Přemyslovců. Prvním Přemyslovcem, o němž se dochovaly písemné zprávy byl
          <strong>kníže Bořivoj</strong>. Bořivojův vnuk <strong>Václav</strong> patřil k nejznámějším přemyslovským panovníkům. Jeho bratr <strong>Boleslav</strong> ho nechal ve Staré Boleslavi
          zavraždit. Václav byl po své smrti prohlášen církví za svatého.
        </p>
        <p class="mt-3">
          Většina obyvatel v těchto dobách bydlela v jednoduchých dřevěných domech soustředěných v malých vesnicích. Postupně vznikala první města, kde vedle dřevěných domů začali bohatí měšťané
          stavět i kamenné domy. Panovníci a velmoži žili v opevněných hradech na vyvýšených místech.
        </p>
        <p class="mt-3">
          Církev si stavěla kostely a kláštery. Všechny tyto kamenné stavby byly budovány v <strong>románském slohu</strong>. Při kostelech a klášterech byly zakládány první školy. Kněží a mniši byli
          po dlouhou dobu jedinými lidmi, kteří uměli <strong>číst</strong> a <strong>psát</strong>. V písařských klášterních dílnách se ručně psaly knihy.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Rozkvět Českého království, vláda přemyslovských králů</h3>
        <p class="mt-3">
          Ve 13. století nastalo období <strong>rozkvětu českého státu</strong>. Přemyslovci byli uznávanými panovníky i u ostatních evropských států. Došlo k povýšení dosavadních čekých knížat na
          <strong>krále</strong>.
        </p>
        <p class="mt-3">
          K největšímu rozmachu došlo za vlády krále <strong>Přemysla Otakara II.</strong>, který byl označován za "krále železného a zlatého". Území Českého království tehdy sahalo až k Jaderskému
          moři. Tato Přemyslova sláva však trvala jen krátkou dobu.
        </p>
        <p class="mt-3">
          Jeho vnuk <strong>Václav III.</strong> sice získal polskou i uherskou korunu, avšak <strong>v roce 1306</strong>
          byl v Olomouci zavražděn. Byl posledním mužem rodu Přemyslovců s nárokem na královský titul. Proto se říká, že jím rod Přemyslovců vymřel "po meči"; meč totiž představoval symbol mužství.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Vláda Lucemburků, Karel IV.</h3>
        <p class="mt-3">
          Po Přemyslovcích nastoupili na český královský trůn <strong>Lucemburkové</strong>. \nejznámějším
          panovníkem tohoto rodu se stal velmi vzdělaný císař <strong>Karel IV.</strong>, který bývá označován
          za nejvýznamnějšího panovníka v celé tisícileté historii českého státu. To dokládá označení, jehož
          se mu dostalo hned p smrti; byl označen za "Otce vlasti". Za jeho vlády se mnoho stavělo (Karlův most, 
          Karlštejn, Nové Město pražské) a v Praze byla založena první univerzita ve střední Evropě. Praha se stala 
          po dobu Karlovy vlády jedním z nejvýznamnějších evropských měst.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Husitské války</h3>
        <p class="mt-3">
         Po smrti Karla IV. propukly vážné <strong>rozpory v katolické církvi</strong>. Kněží, mniši i papežové
         místo toho, aby oddaně sloužili Bohu, shromažďovali do svých rukou majetek a mc ve státě. Bohatli zejména 
         prodejem odpustků. Mnozí kněží však tyto zlořády kritizovali. Mezi nimi vynikal svými kázáními <strong>Jan Hus</strong>. 
         Církevní hodnostáři ho chtěli umlčet. Protože své myšlenky odmítl odvolat, byl 6. červemce 1415 upálen. Tento 
         den si každoročně připomínáme jako státní svátek.
        </p>
        <p>
          Upálení Jana Husa vyvolal v Čechách bouři odporu a přerostl v <strong>husitské války</strong>. Papež 
          organizoval proti husitům <strong>křížové výpravy</strong>. Ty však byly husitským vojskem poraženy.
          Husitům velel <strong>Jan Žižka z Trocnova</strong>.
        </p>
        <p>
          Nakonec propukly uvnitř husitského hnutí rozpory, které vyvrholily vzájemnou bitvou. Stoupenci radikálního
          husitského směru byli poraženi.Moc církve se znovu začala upevňovat.
        </p>
      </div>
       <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Život v středověku</h3>
        <p class="mt-3">
         Nejvyšší postavení ve státě měla hned po panovníkovi <strong>šlechta</strong>, které patřily pole, lesy, louky, rybníky
         i celé vesnice s poddanými. Šlechta se dělila na <strong>pány</strong> (bohatší část) a na <strong>rytíře</strong>
         (nebo též na <strong>zemany</strong>, chudší část). Páni sídlili na hradech, zemané žili v tvrzích.
        </p>
        <p>
          <strong>Církev</strong> vlastnila kláštery, kostely a také vesnice s poddanými.
        </p>
        <p>
          Většina lidí žila na vesnicích. Nejpočetnější skupinou venkovského obyvatelstva byli <strong>poddaní</strong>, kteří museli 
          odvádět králi, šlechtě i církvi jak peníze, tak i část své úrody z polí.
        </p>
        <p>
          Ve městech žili převážně <strong>obchodníci </strong> a <strong>řemeslníci</strong>. Nejhůř se žilo 
          <strong>venkovské i městské chudině</strong>.
        </p>
        <p>
          Od poloviny 14. století vystřídaly románský sloh stavby <strong>gotického slohu</strong>. Na těžko přístupných místech se budovaly
          mohutné hrady, ve městech nádherné kláštery a chrámy. Nejznámějším z nich se stal
          <strong>Chrám sv. Víta v Praze</strong>.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Husitský král Jiří z Poděbrad, vláda Jagellonců</h3>
        <p class="mt-3">
          Po husitských válkách českým zemím krátce vládl český šlechtic <strong>Jiří z Poděbrad</strong> ("husitský král"), který 
          jako jediný z českých panovníků něměl královský původ.
        </p>
        <p>
          Po Jiřím z Poděbrad nastoupil na český trůn nový panovnický rod, tentokráte z Polska - rod <strong>Jagellonců</strong>
          Vládl u nás zhruba půl století.
        </p>
      </div>
      <div class="py-3 text-gray-700">
        <h3 class="text-xl font-medium text-blue-600">Nástup Habsburků na český trůn</h3>
        <p class="mt-3">
         Po Jagelloncích přišli v roce 1526 na český trůn rakouští <strong>Habsburkové</strong>. České země se staly součástí velké 
         středoevropské habsburské monarchie, kterou vedle nich tvořily rakouské země a Uherské království.
        </p>
        <p>
          Až na císaře <strong>Rudolfa II,</strong>, který si zvolil za sídelní město Prahu, dávali Habsburkové přednost Vídni.
          Přesto zůstávaly české země kulturně a hospodářsky nejvyspělejší částí monarchie. Rudolf II. podporoval rozvoj věd a umění. 
          Do Prahy pozval řadu významných učenců a malířů z celé Evropy.
        </p>
        <p>
          S nástupem Habsburků na český trůn <strong>končilo období středověku</strong> a začínal nový dějinný úsek, který nazýváme 
          <strong>novověk</strong>.
        </p>
        <p>
          Do českých zemí začal pronikat nový umělecký směr zvaný <strong>renesance</strong>. Panstvo si přestavovalo své hrady 
          na pohodlné zámky obklopené zahradami a oborami se zvěří.
        </p>
        <p>
          Bohatí měšťané si stavěli ve městech ozdobné domy. Rostl význam vzdělání. Zakládaly se městské školy.
        </p>
        <p>
          Stále více lidí toužilo naučit se číst, psát a počítat. <strong>Vynález knihtisku</strong> umožnil vydávat větší množství knih.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
